// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter_schema.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { CloneEncounterSchemaReq, CloneEncounterSchemaResp, CreateEncounterSchemaReq, CreateEncounterSchemaResp, DeleteEncounterSchemaReq, DeleteEncounterSchemaResp, GetEncounterSchemaReq, GetEncounterSchemaResp, ListEncounterSchemasReq, ListEncounterSchemasResp, ListEncounterSchemaUsageReq, ListEncounterSchemaUsageResp, RestoreEncounterSchemaReq, RestoreEncounterSchemaResp, UpdateEncounterSchemaReq, UpdateEncounterSchemaResp } from "./svc_encounter_schema_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.EncounterSchemaService
 */
export const EncounterSchemaService = {
  typeName: "com.diagnocat.scribe.EncounterSchemaService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Get
     */
    get: {
      name: "Get",
      I: GetEncounterSchemaReq,
      O: GetEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.List
     */
    list: {
      name: "List",
      I: ListEncounterSchemasReq,
      O: ListEncounterSchemasResp,
      kind: MethodKind.Unary,
    },
    /**
     * Schemas that encounters were actually captured under, with their counts.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.ListUsage
     */
    listUsage: {
      name: "ListUsage",
      I: ListEncounterSchemaUsageReq,
      O: ListEncounterSchemaUsageResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Create
     */
    create: {
      name: "Create",
      I: CreateEncounterSchemaReq,
      O: CreateEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Update
     */
    update: {
      name: "Update",
      I: UpdateEncounterSchemaReq,
      O: UpdateEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
    /**
     * Soft-delete, reversed by Restore. System-owned schemas are protected.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteEncounterSchemaReq,
      O: DeleteEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreEncounterSchemaReq,
      O: RestoreEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
    /**
     * Copies community or official assets into the caller's organization.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterSchemaService.Clone
     */
    clone: {
      name: "Clone",
      I: CloneEncounterSchemaReq,
      O: CloneEncounterSchemaResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

